export default "__VITE_ASSET__B8Fa45PT__"